module Meevo.Plugins.MerchantAccounts {
    "use strict";

    /**
    * Devices Section of Merchant Account 
    */
    export class DevicesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.MerchantAccount> {
        customAuditCriteria = {
            nounId: Model.NounEnum.MerchantAccountDevices,
        };

        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected modalService: Components.Modal.IModalService,
            protected tippyService: Meevo.Plugins.Tippy.TippyService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            this.modalService = modalService;
        }

        // Tippy could have been disabled, or the AB#140176 dual-lock business setting turned off, since a
        // device was previously paired (or the device edited while either was off, hiding the field) -
        // clear any stale pairing on save rather than silently persisting it. Must use a fresh, awaited
        // check for Tippy itself here (not the cached `isTippyEnabled` field on the context, which
        // defaults to false until its own async check resolves) - otherwise a save that races that
        // resolution would wipe out a pairing the admin just entered, even though Tippy is actually enabled.
        // enableDualLockBehavior is read synchronously (a plain app setting, no async check needed) and
        // checked first so a dual-lock-off save skips the Tippy round trip entirely.
        // Only devices with a pairing to clear even need either check, and the Tippy check must never
        // block or delay saving any other device - fail safe (don't clear) and always save if it errors out.
        saveDevice(item: any, vm: any): void {
            if (!item || !item.tippyKioskId) {
                vm.save();
                return;
            }

            if (this.appSettings.APP_BUSINFOSETTINGS.registerSettings.enableDualLockBehavior === false) {
                item.tippyKioskId = null;
                vm.save();
                return;
            }

            this.tippyService.isTippyConfigured()
                .catch(() => true)
                .then((isEnabled) => {
                    if (!isEnabled) {
                        item.tippyKioskId = null;
                    }

                    vm.save();
                });
        }

        unlockItem(item: any): void {
            let payload = {
                merchantAccountId: item.merchantAccountId,
                merchantTerminalId: item.id,
                serialNumber: item.serialNumber,
                externalTerminalId: item.externalTerminalId,
                lockedByUserId: item.lockedByUserId,
                lockedDateTime: item.lockedDateTime,
                lockVersion: item.lockVersion
            };
            this.dataService.customMethodData('api/MerchantTerminal/Unlock', 'POST', payload)
                .then((data: any) => {
                    item.hasLockForProcessing = false;
                    this.modalService.alert(`The terminal ${item.displayName} has been unlocked.`);
                });
        }
    }
}